export default __webpack_public_path__ + "static/media/records.b720993d.jpg";